// $(document).ready(function() {
//   $("button[name='toggle']").click(function(e) {
//       e.preventDefault(); // Prevent default button action

//       let button = $(this); // Reference to the clicked button
//       let textElem = $("#text"); // Reference to the text element that toggles

//       let elemText = button.text().trim(); // Get and trim button text
//       let containerElem = button[0]; // Get the DOM element of the button

//       if (elemText === "Read More") {
//           // Change button text to 'Read Less' and expand the text
//           button.text("Read Less");
//           textElem.slideDown();
//       } else {
//           // Change button text to 'Read More'
//           button.text("Read More");
//           // Use setTimeout to give a slight delay to ensure scroll starts smoothly
//           textElem.slideUp({duration: 400});
//           // Scroll to the element smoothly and simultaneously slide up
//           containerElem.scrollIntoView({ behavior: 'smooth', block: 'center' });
//       }
//   });
// });
const plusIcon = `
<svg class="toggle-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
  <path fill="currentColor" d="M8 2a.5.5 0 01.5.5V7.5H13.5a.5.5 0 010 1H8.5V13.5a.5.5 0 01-1 0V8.5H2.5a.5.5 0 010-1H7.5V2.5A.5.5 0 018 2z"/>
</svg>`;

const minusIcon = `
<svg class="toggle-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
  <path fill="currentColor" d="M2.5 8a.5.5 0 01.5-.5h10a.5.5 0 010 1h-10a.5.5 0 01-.5-.5z"/>
</svg>`;

document.querySelectorAll('.toggle-button').forEach(function (button) {
    // set default state immediately
    button.innerHTML = `Show More ${plusIcon}`;

    button.addEventListener('click', function () {
        const contentContainer = this.closest('.content-container');
        const extraContent = contentContainer.querySelector('.extra-content');
        const isExpanded = contentContainer.classList.toggle('expanded');

        if (isExpanded) {
            extraContent.style.height = extraContent.scrollHeight + 'px';

            extraContent.addEventListener(
                'transitionend',
                function () {
                    extraContent.style.height = 'auto';
                },
                { once: true }
            );

            this.innerHTML = `Show Less ${minusIcon}`;
        } else {
            extraContent.style.height = extraContent.scrollHeight + 'px';
            void extraContent.offsetHeight;
            extraContent.style.height = '0';

            this.innerHTML = `Show More ${plusIcon}`;

            window.scrollTo({
                top: contentContainer.offsetTop,
                behavior: 'smooth',
            });
        }
    });
});